import { Component, OnInit, ViewEncapsulation } from '@angular/core';
//import {MatTabsModule} from '@angular/material/tabs';
import {TabViewModule} from 'primeng/tabview';
import {ButtonModule} from 'primeng/button';
import { Router } from '@angular/router';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { IResetPassword } from 'src/app/models/IResetPassword';
import { MessageService } from 'primeng/api';

@Component({
  selector: 'app-forgetpassword',
  templateUrl: './forgetpassword.component.html',
  styleUrls: ['./forgetpassword.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ForgetpasswordComponent implements OnInit {
  activeIndex1: number = 0;

  activeIndex2: number = 0;

  scrollableTabs: any[] = Array.from({ length: 50 }, (_, i) => ({ title: `Tab ${i + 1}`, content: `Tab ${i + 1} Content` }));

  ///
  loading=false;
  _email:string;
  _phoneNumber:string;
  newPassword:string;
  confirmPassword:string;
  _errorMessage:string=''; 
  isCodeSent:boolean=false;
  pinCode:string;
  get errorMessage():string
  {
    return this._errorMessage;
  }
  set errorMessage(value:string)
  {
   this._errorMessage = value;
   this.messageService.add({severity: 'error', summary: 'Error', detail:this._errorMessage, life: 2000});
   //this.alert.error(this._errorMessage);
  }
  get email():string
  {
    return this._email;
  }
  set email(value:string)
  {
   this._email = value;
   this._phoneNumber = "";
  }
  get phoneNumber():string
  {
    return this._phoneNumber;
  }
  set phoneNumber(value:string)
  {
   this._phoneNumber = value;
   this._email = "";
  }
  constructor(private messageService:MessageService,private httpHelper:HttphelperService,private router:Router) { }
  backToLogin():void{
    window.location.href = 'login';
  }
  ngOnInit(): void {
  }
  verifyPin():void
  {
    if(this.pinCode == "" || this.pinCode == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter Pin Code", life: 2000});
      //this.alert.warn("Please Enter Pin Code");
      return;
    }
    if(this.newPassword == "" || this.newPassword == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter New Password", life: 2000});
      //this.alert.warn("Please Enter New Password");
      return;
    }
    if(this.confirmPassword == "" || this.confirmPassword == undefined)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter Confirm Password", life: 2000});
      //this.alert.warn("Please Enter Confirm Password");
      return;
    }
    if(this.newPassword != this.confirmPassword)
    {
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Confirm Password Doesn't Match New Password", life: 2000});
      //this.alert.warn("Confirm Password Doesn't Match New Password");
      return;
    }
     var url = "api/Account/ChangePasswordForForgetPassword";
     var model : IResetPassword = {ActivationCode:this.pinCode,Password:this.newPassword,ConfirmPassword:this.confirmPassword};
     this.loading = true;
     this.httpHelper.postRequest(url,false,model).subscribe({
      next : res => {
        if(res.Success)
        {           
          this.messageService.add({severity: 'success', summary: 'Success', detail:"Password Reseted Successfully", life: 2000});
          localStorage.clear();
          //this.router.navigate['/login'];
           window.location.href='login';
        }
        else
        {
          this.errorMessage = res.Message;
        }
        this.loading = false
      },
     error:err => {this.errorMessage = err ; this.loading = false;}
     });
  }
  getActivationSms():void
  {
    if(this.phoneNumber == "" || this.phoneNumber == undefined)
    {        
      this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter Phone Number", life: 2000});
      //this.alert.warn("Please Enter Phone Number");
      return;
    }
    var url = "api/Account/ForgetPassword?UserName="+this.phoneNumber+"&codeType=1";
    this.loading = true;
    this.httpHelper.getRequest(url,false).subscribe({
      next : res => {
        if(res.Success)
        {
           //this.pinCode = res.Data; // REMOVE Immediate
           this.isCodeSent = true;
           this.messageService.add({severity: 'success', summary: 'Success', detail:"Pin Code Sent Successfully", life: 2000});
          // this.alert.success("Pin Code Sent Successfully");
        }
        else
        {
          this.errorMessage = res.Message;
        }
        this.loading = false;
      },
     error:err => {this.errorMessage = err;this.loading = false;}
    });
  }
  getActivationEmail():void
  {
       if(this.email == ""|| this.email == undefined)
       {
        this.messageService.add({severity: 'warn', summary: 'Warning', detail:"Please Enter Email", life: 2000});
        //this.alert.warn("Please Enter Email");
        return;
       }
       var url = "api/Account/ForgetPassword?UserName="+this.email+"&codeType=0";
       this.loading = true;
       this.httpHelper.getRequest(url,false).subscribe({
         next : res => {
           if(res.Success)
           {
              //this.pinCode = res.Data;
              this.isCodeSent = true;
              this.messageService.add({severity: 'success', summary: 'Success', detail:"Pin Code Sent Successfully", life: 2000});
             // this.alert.success("Pin Code Sent Successfully");
           }
           else
           {
             this.errorMessage = res.Message;
           }
           this.loading = false;
         },
        error:err => {this.errorMessage = err; this.loading = false;}
       });    
  }

}
